import script from "./AccordionIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionIndicator.vue?vue&type=style&index=0&id=afad8954&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afad8954"]])

export default __exports__